export default __webpack_public_path__ + "7160caa814ef926bf12f3951d794eb54.png";